'use strict';
module.exports = function (obj) {
	return Object.prototype.toString.call(obj).replace(/^\[object (.+)\]$/, '$1').toLowerCase();
};



//////////////////
// WEBPACK FOOTER
// ./~/obj-type/index.js
// module id = 73
// module chunks = 0